export const calcularIMC = (peso,talla) => {
    if(!peso  || !talla || peso <= 0 || talla <= 0 ) return null;
    const tallaEnMetros = talla > 3 ? talla / 100 : talla;
    const imc = peso / (tallaEnMetros * tallaEnMetros);
    return parseFloat(imc.toFixed(2));
}